<template>
  <div class="main-container">
    <div class="blur-background" :style="{ 'background-image': computedBackgroundImage }"></div>
    <NotFound v-if="notFound" />
    <Loader v-if="loading" />

    <div class="share-container" v-if="post">
      <div class="uhive_banner--container desktop" id="banner_desktop" v-if="desktopBanner" >
        <a  href="https://www.uhive.com/growth-fund?utm_source=Shares&utm_medium=Banner&utm_campaign=Post-Share-Growth-Fund" 
          target="_blank"
        >
          <img :src="desktopBanner" />
        </a>
      </div>

      <div class="uhive_banner--container mobile" id="banner_mobile" v-if="mobileBanner" >
        <a  href="https://www.uhive.com/growth-fund?utm_source=Shares&utm_medium=Banner&utm_campaign=Post-Share-Growth-Fund" 
          target="_blank"
        >
          <img :src="mobileBanner" />
        </a>
      </div>
      <div v-bind:class="getHeaderClass">
        <Location :locationName="post.place.name" v-if="post.place && showControls" />
        <Moderation :moderationStatus="post.moderationStatus"  :moderationSummary="post.moderationSummary" :interestId="post.interest.id" v-if="post.moderationStatus != 0  && showControls"  @click.native="showPopUp"/> 
      </div>
      <a href="https://www.uhive.com" v-bind:class="getUhiveLogoClass" target="_blank">
        <img src="https://cdn.uhive.com/wp-content/uploads/2022/04/Uhive-u-logo.svg" />
      </a>
      <SideBar :showUHiveBanner="desktopBanner ? true : false"/>


      <ReactionsBar
        :likesCount="post.reactions.likes"
        :dislikesCount="post.reactions.dislikes"
        :sharesCount="post.reactions.shares"
        @click.native="showPopUp"
        v-if="showControls"
      />
      <PostContent
        v-if="post"
        :attachments="post.attachments"
        :ogTags="post.og"
        :text="post.content"
        :postID="post.id"
        :continue_video="continue_video"
        @showpopup="showPopUp"
        @showVideoPopup_event="showPopUp_video"
        @is_media_clicked="hideShowControls(false, $event)"
        @click.native="hideShowControls(false)"
      />
      <div class="main-footer" v-if="showControls">
        <SpaceInfo
          :avatarURL="post.space.logo"
          :avatarColor="post.interest.color"
          :spaceTitle="post.space.name"
          :interest="post.interest.name"
          :isVerified="post.space.verified"
          :isImported="isImported"
          @click.native="showPopUp"
        />
        <PostText
          v-if="postType != PostTypes.OG && postType != PostTypes.TEXT"
          :content="post.content"
          @click.native="showPopUp"
        />
        <Awards :awards="post.awards" v-if="post.awards.length > 0"  @click.native="showPopUp" />
        <Comments
          :commentsCount="post.reactions.comments"
          @click.native="showPopUp"
        />
        
        <div class="seek-bar" v-if="postContainsVideo"></div>
      </div>
      <DownloadPopup @popupClosed="showpopup = false" :showpopup="showpopup" />
      <ContinueWatchingPopUp
        @popupClosed="showpopup_video = false"
        :showpopup_video="showpopup_video"
      />
    </div>
  </div>
</template>

<script>
  import PostContent from "../../components2/post-content/post-content.vue";
  import ReactionsBar from "../../components2/decorations/reactions-bar.vue";
  import Comments from "../../components2/decorations/comments.vue";
  import SpaceInfo from "../../components2/decorations/space-info.vue";
  import Location from "../../components2/decorations/location.vue";
  import Moderation from "../../components2/decorations/moderation.vue";
  import PostText from "../../components2/post-content/post-text.vue";
  import Awards from "../../components2/decorations/post-awards.vue";
  import NotFound from "../../components2/not-found.vue";
  import Loader from "../../components2/loader.vue";
import SideBar from "../../components2/side-bar.vue";
import {
  getPostTypeBasedOnAttachments,
  postContainsVideo,
} from "../../components2/post-content/helpers";

import { reduceAssetDimensions } from "../../../../helpers/assets";
import DownloadPopup from "../../components2/popups/download-popup.vue";
import ContinueWatchingPopUp from "../../components2/popups/continue-watching-popup.vue";
import ReRenderer from "../../mixins/re-renderer.vue";
import { SpaceFlags, BannerPagesIDs, BannersNumbers, PostTypes } from '../../components2/post-content/enums'
import { getYoutubeThumbURL }  from "../../../../helpers/formatters.js";

export default {
  name: "PostView",
  mixins: [ReRenderer],
  components: {
    PostContent: PostContent,
    PostText: PostText,
    ReactionsBar: ReactionsBar,
    Comments: Comments,
    SpaceInfo: SpaceInfo,
    DownloadPopup: DownloadPopup,
    ContinueWatchingPopUp: ContinueWatchingPopUp,
    NotFound: NotFound,
    Loader: Loader,
    SideBar: SideBar,
    Location: Location,
    Moderation: Moderation,
    Awards: Awards,
  },
  methods: {
    showPopUp(event) {
      this.showpopup = true;
      if (event) event.stopPropagation();
    },
    showPopUp_video(event) {
      this.showpopup_video = true;
      if (event) event.stopPropagation();
    },
    setUpMediaSession() {
      //https://developer.mozilla.org/en-US/docs/Web/API/Media_Session_API
      //https://genie9.atlassian.net/browse/UHV-17791
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: "Uhive - A Social Metaverse",
        artwork: [
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_96x96,
            sizes: "96x96",
            type: "image/png",
          },
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_128x128,
            sizes: "128x128",
            type: "image/png",
          },
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_192x192,
            sizes: "192x192",
            type: "image/png",
          },
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_256x256,
            sizes: "256x256",
            type: "image/png",
          },
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_384x384,
            sizes: "384x384",
            type: "image/png",
          },
          {
            src: process.env.VUE_APP_MEDIA_SESSION_LOGOS_512x512,
            sizes: "512x512",
            type: "image/png",
          },
        ],
      });
    },
    hideShowControls(onlyHide, is_media_clicked=undefined){
      if(is_media_clicked){
        is_media_clicked = is_media_clicked['is_media_played'];
      }

      if (!this.is_controls_hidden || is_media_clicked){
        this.showControls = false;
      }
      else{
        if(!onlyHide){
          this.showControls = true;
          clearInterval(this.interval);
          this.interval = setInterval(this.hideShowControls, 8000, true);
        }
      }

      if(is_media_clicked){
        this.is_controls_hidden = true;
      }
      else{
        this.is_controls_hidden = !this.is_controls_hidden;
      }
    },
  },
  data() {
    return {
      reRenderCssSelectors: [
        {
          jquerySelectors: ".share-container",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
      PostTypes: PostTypes,
      fullyRendered: false,
      showpopup: false,
      showpopup_video: false,
      continue_video: false,
      is_controls_hidden: false,
      interval: null,
      showControls: true,
      projectID: process.env.VUE_APP_PROJECT_ID,
      pageID: BannerPagesIDs.POSTS,
      bannerNumber: BannersNumbers.GROWTH_FUND,
    };
  },
  props: {
    postID: {
      type: String,
      required: true,
    },
    isShareSpace: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    if (!this.isShareSpace) this.$store.dispatch("shares/getPost", this.postID);
    this.$store.dispatch("shares/getBanners", {"url": `/web_banners/uhive_ads/${this.projectID}_${this.pageID}_${this.bannerNumber}/desktop_light.png`})
  },
  mounted() {
    this.setUpMediaSession();
    this.$gtm.trackView("Share post page", this.$route.path);
    this.interval = setInterval(this.hideShowControls, 8000, true);
  },
  computed: {
    space() {
      return this.$store.getters["shares/space"];
    },
    postContainsVideo() {
      return postContainsVideo(this.post.attachments);
    },
    postType() {
      return getPostTypeBasedOnAttachments(this.post.attachments, this.post.og);
    },
    post() {
      var post = this.$store.getters["shares/post"];
      if (post) {
        if (post.isSharedPost) {
          return post.sharedFrom;
        } else return post;
      } else {
        return post;
      }
    },
    computedBackgroundImage() {
      let post = this.$store.getters["shares/post"];
      let imgURL;
      if (!post) {
        return ``;
      }

      // Normal Posts
      if (!post.isSharedPost){
        let postType = getPostTypeBasedOnAttachments(post?.attachments, post?.og);

        switch (postType) {
          case PostTypes.MEDIA:
            imgURL = post?.attachments[0]?.url;
            break;

          case PostTypes.OG:
            imgURL = post?.og?.image
            break;

          case PostTypes.YOUTUBE:
            imgURL = getYoutubeThumbURL(post?.attachments[0].link)
            break;

          default:
            imgURL = ``
            break;
        }
        return `url(${imgURL})`
      }

      // Shared Posts
      if (post.isSharedPost){
        let postType = getPostTypeBasedOnAttachments(post?.sharedFrom?.attachments, post?.sharedFrom?.og);
        switch (postType) {
          case PostTypes.MEDIA:
            imgURL = post?.sharedFrom?.attachments[0]?.url;
            break;

          case PostTypes.OG:
            imgURL = post?.sharedFrom?.og?.image
            break;

          case PostTypes.YOUTUBE:
            imgURL = getYoutubeThumbURL(post?.sharedFrom?.attachments[0].link)
            break;

          default:
            imgURL = ``
            break;
        }
        return `url(${imgURL})`
      }
      return ``;
    },
    desktopBanner(){
      let bannerURL = this.$store.getters["shares/banner"];
      let errorCode = this.$store.state.shares.banner.errorCode;

      if (bannerURL && errorCode === null){
        const CLOUDFRONT_URL = process.env.VUE_APP_CLOUDFRONT_URL;
        let url = CLOUDFRONT_URL + `/web_banners/uhive_ads/${this.projectID}_${this.pageID}_${this.bannerNumber}/desktop_light.png`;
        return url
      }

      return false
    },
    mobileBanner(){
      let bannerURL = this.$store.getters["shares/banner"];
      let errorCode = this.$store.state.shares.banner.errorCode;

      if (bannerURL && errorCode === null){
        const CLOUDFRONT_URL = process.env.VUE_APP_CLOUDFRONT_URL;
        let url = CLOUDFRONT_URL + `/web_banners/uhive_ads/${this.projectID}_${this.pageID}_${this.bannerNumber}/mobile_light.png`;
        return url
      }
      return false
    },
    getHeaderClass() {
      return this.desktopBanner ? "header_with_banner" : "header";
    },
    ogTags() {
      if (this.post.og && !this.post.attachments) {
        return { ...this.post.og, type: "article" };
      } else {
        let [w, h] = [850, 850];

        let image = { url: null, width: null, height: null };

        if (this.post.attachments.length) [image] = this.post.attachments;
        else image.url = this.post.space.logo;

        return {
          title: "UHive",
          type: "article",
          url: window.location.href,
          image: reduceAssetDimensions(image.url, w, h),
          width: w,
          height: h,
          description: this.post.content
            ? this.post.content.substring(0, 50)
            : this.post.space.name,
        };
      }
    },
    loading() {
      return this.$store.state.shares.post.fetching;
    },
    notFound() {
      return (
        this.$store.state.shares.post.errorCode != null ||
        this.$store.state.shares.space.errorCode != null
      );
    },
    isImported() {
      if (this.post.space.verified && (this.post.space.flags & SpaceFlags.FAKE) == SpaceFlags.FAKE){
        return true;
      } else {
        return false;
      }
    },
    getUhiveLogoClass() {
      return this.desktopBanner ? "logo-with-banner" : "uhive-logo";
    },
  },
  watch: {
    showpopup: function (value) {
      this.continue_video = !value;
    },
  },
  metaInfo() {
    if (this.post && !this.isShareSpace) {
      return {
        title: `${this.post.space.name} on Uhive`,
        meta: [
          {
            property: "og:type",
            content: this.ogTags.type,
          },
          {
            property: "og:description",
            content: this.ogTags.description,
          },
          {
            property: "og:title",
            content: this.ogTags.title,
          },
          {
            property: "og:url",
            content: this.ogTags.url,
          },
          {
            property: "og:image",
            content: this.ogTags.image,
            itemprop: "image",
          },
          {
            property: "og:image:width",
            content: this.ogTags.width,
          },
          {
            property: "og:image:height",
            content: this.ogTags.height,
          },
          {
            name: 'robots',
            content: 'noindex'
          },
        ].filter((tag) => !!tag.content),
      };
    } else if (this.space && this.isShareSpace) {
      return {
        title: `${this.space.name} on Uhive`,
        meta: [
          {
            property: "og:type",
            content: "article",
          },
          {
            property: "og:description",
            content: this.space.name,
          },
          {
            property: "og:title",
            content: this.space.interest.name,
          },
          {
            property: "og:url",
            content: window.location.href,
          },
          {
            property: "og:image",
            content: reduceAssetDimensions(this.space.logo),
            itemprop: "image",
          },
        ],
      };
    } else {
      return { title: "Uhive - A Social Metaverse" };
    }
  },
};
</script>


<style scoped>
@font-face {
  font-family: SFUIDisplay;
  src: url(../../components2/post-content/Roboto-Regular.ttf);
}

.header {
    display: inline-flex;
    align-items: baseline;
    flex-direction: column;
    position: absolute;
    left: 0.5rem;
    top: 5rem;
    gap: 1rem;
    width: 80%;
  }
.header_with_banner{
    display: inline-flex;
    align-items: baseline;
    flex-direction: column;
    position: absolute;
    left: 0.5rem;
    top: 14rem;
    gap: 1rem;
    width: 80%;
  }

.seek-bar {
  /* border: 2px dotted red ; */
  height: 3vh;
}
html {
  margin: 0;
  padding: 0;
  height: 100%;
  background: rgb(0, 0, 0);
  border: 1px solid yellow;
}
.desktop{
  display:block;
}
.mobile{
  display: none;
}
.blur-background {
    position: absolute;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(75px);
}
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
}
.uhive_banner--container{
  position: absolute;
  left: 0 !important;
  top: 0;
  z-index: 1;
  height: auto;
  width: 500px;
  font-family: SFUIDisplay;
  background-color: transparent;
  margin-left: auto;
  margin-right: auto;
  left: 20%;
}
.uhive_banner--container a img{
  width: 100%;
  height: 100%;
}
.share-container {
  font-family: SFUIDisplay;
  background-color: black;
  height: 100vh !important;
  position: relative;
  /* To fix the viewport issue on firefox and mobile browsers and to overcome the browsers bars issue refer for this issue 
  https://css-tricks.com/css-fix-for-100vh-in-mobile-webkit/
  https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
  */
  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  border: 1px solid #333;
}
.full-height{
  height: 100vh !important;
}
.slickslider {
  font-family: SFUIDisplay;
  color: rgb(255, 255, 255);
  margin: auto;
  padding: 0;
  height: 100%;
  max-height: 100%;
  background: rgb(0, 0, 0);
  /* float: left; */
  width: 100%;
  position: relative;
}
.uhive-logo {
  position: absolute;
  z-index: 1;
  top: 1rem;
  left: 1rem;
  padding: 0;
  margin: 0;
}
.uhive-logo img {
  width: 2rem;
}
.logo-with-banner{
  position: absolute;
  z-index: 1;
  top: 9rem;
  left: 1rem;
  padding: 0;
  margin: 0;
}
.logo-with-banner img {
  width: 2rem;
}
@media only screen and (max-width: 320px) {
  .header{
    top: 8rem !important;
  }
}
@media only screen and (max-width: 700px) {
  .share-container {
    width: 100%;
  }
  .header{
    top: 12rem;
    width: 96%;
  }
  .uhive_banner--container{
    width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .logo-with-banner{
    top: 8rem;
  }
  .volume-with-banner{
    top: 8rem;
  }
}
@media only screen and (max-width: 1024px) {
  .desktop{
    display: none;
  }
  .mobile{
    display: block;
  }

}
@media only screen and (min-width: 704px) and (max-width: 1024px) {
  .uhive_banner--container{
    width: 500px;
  }
}
p,
span {
  color: white;
}
#close-banner-btn{
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
}

/* Flex  */
.main-footer {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 1rem 1rem 1rem;
  gap: 1rem;
}
</style> 